import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"class_supply",
    list_id:"supply_list_cinfirm_reset",
    x_column_list_arr:[
      {"key":"a_stu_name","name":"이름","width":"90","is_show":"1"},
      {"key":"a_date","name":"청구일","width":"90","is_show":"1"},
      {"key":"a_title","name":"수납명","width":"160","is_show":"1"},
      {"key":"a_money","name":"청구액","width":"70","is_show":"1"},
      {"key":"a_discount_money","name":"할인액","width":"60","is_show":"1"},
      {"key":"a_money_sum","name":"청구합계","width":"70","is_show":"1"},
      {"key":"a_pay_sort","name":"결제수단","width":"80","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':200,
      'order_id':'a_date, a_stu_name, a_seq',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;